import React from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import cx from "classnames";

const styles = theme => ({
  buttonStyle: {
    ...theme.typography.defaultFont,
    fontWeight: 700,
    borderRadius: "18px",
    color: "#FFFFFF",
    cursor: "pointer",
    boxShadow: "none",
    "-webkit-tap-highlight-color": "transparent",
    "&:disabled": {
      color: "#ffffff",
      backgroundColor: "rgba(42, 137, 246, 0.4)",
      border: "none"
    }
  }
});

const CustomButton = ({
  classes,
  onClick,
  className,
  disabled = false,
  children,
  type = "submit",
  ...otherProps
}) => (
  <>
    <button
      color="primary"
      className={cx(classes.buttonStyle, className)}
      onClick={onClick}
      disabled={disabled}
      type={type}
      {...otherProps}
    >
      {children}
    </button>
  </>
);

CustomButton.propTypes = {
  classes: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  Icon: PropTypes.any,
  disabled: PropTypes.bool
};

export default withStyles(styles)(CustomButton);
